"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { cashApplication } from "@/content/agent-use-cases/cash-application";

export default function CashApplicationUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={cashApplication} locale={locale} />;
}
